import request from '@/utils/requestNews'

export function list (data) {
  return request({
    url: '/news/list',
    method: 'post',
    data
  })
}
export function find (data) {
  return request({
    url: '/news/find',
    method: 'post',
    data
  })
}
export function creditTop (data) {
  return request({
    url: '/credit/top',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/news.js